import * as React from 'react';

// PACKAGES
import { Tooltip } from 'reactstrap';

// ICONS
import { ReactComponent as AlertIcon } from '../assets/svg/alert-circle.svg';
import FallbackImage from '../assets/svg/image-fallback.svg';

interface CircleImageTypes {
	src?: string;
	isColorBorder?: Boolean;
	extraClass?: string;
	alt?: string;
	size?: number;
	isProfileInComplete?: boolean;
	firstName?: string;
	lastName?: string;
	fullName?: string;
	textLarge?: boolean;
	noGap?: boolean;
}

const CircleImage: React.FC<CircleImageTypes> = ({
	src,
	extraClass,
	alt,
	size,
	isColorBorder,
	isProfileInComplete,
	firstName,
	lastName,
	textLarge,
	fullName,
	noGap
}) => {
	const returnInitialFullName = (text: string) => {
		const firstLetter = text.split(' ')[0].toUpperCase();
		const secondLetter = text.split(' ')[1].toUpperCase();
		return firstLetter[0] + secondLetter[0];
	};

	const [mounted, setIsMounted] = React.useState<boolean>(false);
	const [imageError, setImageError] = React.useState<boolean>(false);

	React.useEffect(() => {
		setIsMounted(true);
	}, []);

	const [imageSrc, setImageSrc] = React.useState<string>(src || '');

	React.useEffect(() => {
		if (mounted) {
			setImageSrc(src || '');
		}
	}, [src]);

	// Tools tip
	const [incompleteProfileTooltipOpen, setincompleteProfileTooltipOpen] = React.useState<boolean>(false);

	const toggleincompleteProfileTooltip = () => setincompleteProfileTooltipOpen(!incompleteProfileTooltipOpen);

	return (
		<>
			{isProfileInComplete && (
				<>
					<AlertIcon id="incompleteProfile" className="alert-icon" />{' '}
					<Tooltip
						placement="right"
						isOpen={incompleteProfileTooltipOpen}
						autohide={false}
						target="incompleteProfile"
						toggle={toggleincompleteProfileTooltip}
					>
						<div className="tooltip-content-start">
							Profile is incomplete. Please review to resolve any outstanding issues.
						</div>
					</Tooltip>
				</>
			)}

			<div className={`image-wrapper ${noGap ? 'no-gap' : ''}`}>
				<div
					className={`circle-image-container ${extraClass ? extraClass : ''} ${isColorBorder ? 'color-border' : ''}`}
					style={{ height: size, width: size }}
				>
					{src && !imageError && (
						<img
							className="circle-image"
							onError={() => {
								if (imageSrc !== FallbackImage) {
									setImageError(true);
								}
							}}
							src={imageSrc}
							alt={alt}
						/>
					)}

					{(imageError || !src) && (
						<div className={`image-fallback ${textLarge ? 'text-large' : ''} `}>
							{fullName ? (
								returnInitialFullName(fullName)
							) : (
								<>
									{firstName && firstName.substring(0, 1).toUpperCase()}{' '}
									{lastName && lastName.substring(0, 1).toUpperCase()}
								</>
							)}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default CircleImage;
